import { useSyncExternalStore } from 'react'
import { getPrefs, setPref, subscribePrefs } from '../lib/prefsStore'
import type { Prefs } from '../lib/prefs'

/** The Settings switches on this device; every component using them follows a toggle. */
export function usePrefs() {
  const prefs = useSyncExternalStore(subscribePrefs, getPrefs, getPrefs)
  return {
    prefs,
    toggle: (key: keyof Prefs) => setPref(key, !getPrefs()[key]),
  }
}
